var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Stepper',{attrs:{"route-index":_vm.index,"routes":_vm.routes},on:{"close":_vm.handleClose,"complete":_vm.pickAddress,"navigate":_vm.navigate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }